// import { NAVBAR_HEIGHT } from 'library/globals';
// import { FileExcelFilled } from '@ant-design/icons';
import { ThemeType } from 'theme/jss-types';
import { commonStyleSheet } from '../../library/common-styles';
import { ZIndex } from 'library/constants';

export const commonStyles = (theme: ThemeType) => ({
    ...commonStyleSheet(theme),
    line: {
        height: 1,
        margin: '12px 0px',
        width: '100%',
        backgroundColor: '#EDEDED',
    },
    main: {
        width: '100%',
        overflow: 'auto',
        maxHeight: 'calc(100vh - 210px)',
        minHeight: 'calc(100vh - 210px)',
        // paddingBottom: 100,
        '& .ant-input, .ant-input-affix-wrapper': {
            boxSizing: 'border-box',
            height: 32,
            border: '1px solid #999999',
            borderRadius: 4,
            marginRight: 2,
        },
        '& .ant-input-number-input': {
            boxSizing: 'border-box',
            height: 32,
            border: '1px solid #999999',
            borderRadius: 4,
            marginRight: 2,
        },
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector': {
            boxSizing: 'border-box',
            height: 32,
            border: '1px solid #999999',
            borderRadius: 4,
            marginRight: 2,
        },
        '& .ant-checkbox-group-item:last-child': {
            display: 'flex',
            color: '#111111',
            fontFamily: 'Open Sans',
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0,
            // marginLeft: 24,
        },
        '& .ant-form-item-control-input': {
            minHeight: 24,
        },
        '& .ant-form-item': {
            marginBottom: 0,
        },
        '& .ant-radio-wrapper': {
            display: 'flex',
            color: '#111111',
            fontFamily: 'Open Sans',
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0,
            margin: '4px 24px 4px 0px',
        },
        '& .ant-picker': {
            boxSizing: 'border-box',
            height: 32,
            border: '1px solid #999999',
            borderRadius: 4,
            marginRight: 2,
        },
        '& .ant-form-item-control-input-content': {
            display: 'flex',
            flexDirection: 'column',
        },
    },
    box: {
        ...commonStyleSheet(theme).flexRow,
        padding: 20,
        alignItems: 'normal',
        boxSizing: 'border-box',
        borderRadius: 4,
        backgroundColor: '#FFFFFF',
    },
    boxS: {
        ...commonStyleSheet(theme).flexColumn,
        padding: 20,
        alignItems: 'normal',
        boxSizing: 'border-box',
        borderRadius: 4,
        backgroundColor: '#FFFFFF',
    },
    boxRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
    singleBox: {
        marginLeft: 3,
        marginRight: 3,
    },
    addressBox: {
        width: '100%',
        margin: '0 20px',
        // maxHeight: `calc((100vh - ${NAVBAR_HEIGHT}px) - 300px)`,
    },
    field: {
        ...commonStyleSheet(theme).flexColumn,
        '& .ant-form-item': {
            marginBottom: 12,
        },
        width: '40%',
    },
    flexRow: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'space-between',
    },
    flexRowVerify: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'flex-start',
    },
    schedule: {
        ...commonStyleSheet(theme).flexRow,
    },
    scheduleBox: {
        ...commonStyleSheet(theme).flexColumn,
        width: '65%',
    },
    title: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '50%',
    },
    titleEway: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '160%',
    },
    dimentionTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '35%',
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
    },
    referenceItemEway: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 16,
    },
    serviceItem: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        marginRight: 0,
        fontSize: 14,
        fontWeight: 550,
    },
    headers: {
        display: 'flex',
        flexDirection: 'row',
    },
    deliveryTimeNew: {
        width: '100%',
        flexDirection: 'row',
        fontSize: 12,
        display: 'flex',
        textAlign: 'left',
        marginRight: 4,
    },
    finalPriceNew: {
        width: '100%',
        flexDirection: 'row',
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
    },
    FinalPrice: {
        width: '100%',
        flexDirection: 'row',
        marginRight: 0,
        fontSize: 12,
        display: 'flex',
        textAlign: 'left',
    },
    column: {
        display: 'flex',
        alignItems: 'center',
    },
    tat: {
        width: '100%',
        fontSize: 12,
    },
    columnNew: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
    },
    tatNew: {
        width: '100%',
        fontSize: 12,
        marginRight: 6,
    },
    deliveryTimeNewNA: {
        fontSize: 12,
        opacity: 0,
    },
    codService: {
        display: 'flex',
        width: '15%',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: 10,
        fontWeight: 500,
        color: 'black',
        fontStyle: 'italic',
    },
    serviceableTitle: {
        marginRight: 8,
    },
    descriptionTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '25%',
    },
    vehicleCategoryTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
    },
    input: {
        width: 250,
        '& .ant-select-selection--single': {
            width: 250,
        },
        minWidth: 250,
        maxWidth: 250,
    },
    formItem: {
        marginBottom: 10,
        width: '45%',
        ...commonStyleSheet(theme).flexRow,
        '& .ant-form-item-label': {
            lineHeight: '14px',
            textAlign: 'left',
            width: '30%',
        },
        '& .ant-form-item': {
            marginBottom: 0,
        },
        '& .ant-form-explain': {
            fontSize: 10,
        },
    },
    msg: {
        marginLeft: '16%',
        color: '#fc036b',
        fontSize: 14,
        fontWeight: 'bold',
    },
    ellipses: {
        fontSize: 12,
        maxWidth: '94%',
        display: 'flex',
        wordWrap: 'break-word',
        whiteSpace: 'initial',
        margin: 0,
        padding: 0,
    },
    labelEllipsis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    textValue: {
        padding: '0 0 12px 8px',
    },
    required: {
        color: '#EB2727',
        fontSize: 12,
    },
    boxFields: {
        width: '100%',
    },
    boxIcon: {
        width: '100%',
        height: 30,
        fontSize: 16,
        color: '#333333',
        textAlign: 'left',
    },
    closeIcon: {
        marginRight: 8,
        cursor: 'pointer',
        color: '#000000',
        letterSpacing: 0,
        fontFamily: 'Open Sans',
        fontWeight: 600,
        fontSize: 16,
    },
    boxMobile: {
        ...commonStyleSheet(theme).flexColumn,
        padding: 10,
        alignItems: 'normal',
        boxSizing: 'border-box',
        borderRadius: 4,
        backgroundColor: '#FFFFFF',
    },
    boxTitle: {
        ...commonStyleSheet(theme).flexColumn,
        fontSize: 16,
        color: '#333333',
        fontWeight: 'bold',
        width: '20%',
        paddingLeft: 6,
    },
    boxTitleMobile: {
        ...commonStyleSheet(theme).flexColumn,
        fontSize: 16,
        color: '#333333',
        fontWeight: 'bold',
        width: '100%',
        paddingLeft: 6,
    },
});

export const singleConsignmentStyles = (theme: ThemeType) => ({
    ...commonStyles(theme),
    main: {
        fontFamily: 'Open Sans',
        letterSpacing: 0,
        '& .ant-drawer-header': {
            padding: 12,
        },
        '& .ant-drawer-body': {
            padding: 0,
            backgroundColor: '#FFFFFF',
        },
        '& .ant-btn-primary': {
            borderRadius: 4,
        },
        zIndex: ZIndex.forms,
    },
    newButton: {
        height: 32,
        borderRadius: '4px',
        fontSize: 12,
        backgroundColor: `${theme.primaryColor} !important`,
        border: `1px solid ${theme.primaryColor}`,
        color: '#FFFFFF',
        fontFamily: 'Open Sans',
        fontWeight: 600,
        letterSpacing: 0,
        marginLeft: '16px',
    },
    newButtonDisabled: {
        height: 32,
        borderRadius: '4px',
        fontSize: 12,
        backgroundColor: '#EDEDED !important',
        border: '1px solid #EDEDED',
        color: '#FFFFFF',
        fontFamily: 'Open Sans',
        fontWeight: 600,
        letterSpacing: 0,
    },
    nextPreButton: {
        color: theme.primaryColor,
        fontWeight: 'bold',
    },
    header: {
        ...commonStyleSheet(theme).flexRow,
        fontWeight: 600,
        fontSize: 20,
        color: '#000000',
        width: '100%',
        maxHeight: 57,
        justifyContent: 'space-between',
        padding: 0,
        fontFamily: 'Open Sans',
        letterSpacing: 0,
    },
    headerReferenceNumber: {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: 12,
        padding: '2px 12px',
        borderRadius: 12,
        backgroundColor: '#F0EDF7',
        color: theme.primaryColor,
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: 0.3,
        lineHeight: '20px',
        whiteSpace: 'nowrap',
    },
    booking: {
        ...commonStyleSheet(theme).flexRow,
        backgroundColor: '#FFF',
        alignItems: 'center',
        padding: '24px 20px',
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        boxSizing: 'border-box',
        boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
    },
    pageSelector: {
        ...commonStyleSheet(theme).flexRow,
        boxSizing: 'border-box',
        border: '1px solid #FAF6EF',
        borderRadius: 4,
        backgroundColor: '#FFF8E7',
        boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
    },
    tabSelector: {
        padding: '10px 20px',
        ...commonStyleSheet(theme).flexRow,
        alignItems: 'center',
        width: '19.5%',
        cursor: 'pointer',
    },
    filledCircle: {
        height: 20,
        width: 20,
        borderRadius: 10,
        border: '2px solid #FFF',
    },
    tabName: {
        marginLeft: 8,
        color: '#111111',
        fontSize: 14,
    },
    tabDescription: {
        fontSize: 10,
        marginLeft: 8,
    },
    tabIcon: {
        height: 24,
        width: 24,
        borderRadius: 12,
    },
    footer: {
        ...commonStyleSheet(theme).flexRow,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        bottom: 0,
        color: '#FFFFFF',
        width: '100%',
        padding: '12px 16px',
        fontSize: 14,
        backgroundColor: 'white',
        opacity: 1,
        zIndex: 5,
    },
    boxFieldsCol: {
        width: '100%',
        ...commonStyleSheet(theme).flexColumn,
        '& .ant-row': {
            width: '100% !important',
            marginLeft: '0 !important',
            marginRight: '0 !important',
        },
        '& .selectDropdown': {
            width: '80px !important',
        },
        '& .ant-form-item': {
            marginBottom: '12px !important',
        },
    },
    form: {
        '& .ant-form-item-explain-error': {
            fontSize: 10,
            paddingTop: '5px',
        },
        '& .ant-form-item-has-error > div > div > div > textarea': {
            border: '1px solid #EB2727',
        },
    },
    creationStepper: {
        position: 'sticky',
        top: 0,
        padding: '20px 16px',
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #EDEDED',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        zIndex: 10,
        '& .ant-steps-item-process .ant-steps-item-icon': {
            backgroundColor: theme.primaryColor,
            borderColor: theme.primaryColor,
        },
        '& .ant-steps-item-finish .ant-steps-item-icon': {
            backgroundColor: '#52C41A',
            borderColor: '#52C41A',
        },
        '& .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon': {
            color: '#FFFFFF',
        },
        '& .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon .ant-steps-icon': {
            color: '#FFFFFF',
        },
        '& .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after': {
            backgroundColor: '#52C41A',
        },
        '& .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after': {
            backgroundColor: theme.primaryColor,
        },
        '& .ant-steps-item-process .ant-steps-item-title': {
            color: theme.primaryColor,
            fontWeight: 600,
        },
        '& .ant-steps-item-finish .ant-steps-item-title': {
            color: '#52C41A',
        },
        '& .ant-steps-item': {
            cursor: 'pointer',
        },
        '& .ant-steps-item-title': {
            fontSize: '12px !important',
            lineHeight: '20px !important',
        },
    },
    creationStepperMobile: {
        position: 'sticky',
        top: 0,
        padding: '12px 10px',
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #EDEDED',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        zIndex: 10,
        '& .ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon': {
            marginRight: '9px !important',
            marginLeft: '16px !important',
        },
        '& .ant-steps-item-process .ant-steps-item-icon': {
            backgroundColor: theme.primaryColor,
            borderColor: theme.primaryColor,
        },
        '& .ant-steps-item-finish .ant-steps-item-icon': {
            backgroundColor: '#52C41A',
            borderColor: '#52C41A',
        },
        '& .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon': {
            color: '#FFFFFF',
        },
        '& .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon .ant-steps-icon': {
            color: '#FFFFFF',
        },
        '& .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after': {
            backgroundColor: '#52C41A',
        },
        '& .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after': {
            backgroundColor: theme.primaryColor,
        },
        '& .ant-steps-item': {
            paddingInlineStart: '0 !important',
            cursor: 'pointer',
            marginRight: '-8px !important',
        },
        '& .ant-steps-item-tail': {
            padding: '4px 8px !important',
            marginInlineStart: '38px !important',
        },
        '& .ant-steps-item-tail::after': {
            height: '1px !important',
            width: '12px !important',
            margin: '0 !important',
        },
        '& .ant-steps-item-content': {
            minHeight: 'auto !important',
            width: '0 !important',
        },
        '& .ant-steps-item-title': {
            display: 'none',
            fontSize: '12px !important',
            lineHeight: '20px !important',
        },
    },
    formContent: {
        flex: 1,
        overflowY: 'auto',
        padding: '0px',
        backgroundColor: '#FFFFFF',
    },
    stepperContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    stepItem: {
        display: 'flex',
        alignItems: 'center',
        flex: '0 0 auto',
    },
    stepCircle: {
        flexDirection: 'column',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s',
        fontSize: 16,
    },
    stepPending: {
        backgroundColor: '#F5F5F5',
        color: '#999999',
    },
    stepActive: {
        backgroundColor: theme.primaryColor,
        color: '#FFFFFF',
    },
    stepComplete: {
        backgroundColor: '#52C41A',
        color: '#FFFFFF',
    },
    stepLine: {
        height: 2,
        minWidth: 30,
        maxWidth: 60,
        flex: '0 0 auto',
        transition: 'all 0.3s',
    },
    linePending: {
        backgroundColor: '#E0E0E0',
    },
    lineActive: {
        backgroundColor: theme.primaryColor,
    },
    lineComplete: {
        backgroundColor: '#52C41A',
    },
    stepIndicator: {
        textAlign: 'center',
        fontSize: 12,
        color: '#999999',
        marginBottom: 4,
        fontWeight: 600,
    },
    stepIndicatorMobile: {
        textAlign: 'center',
        fontSize: 12,
        color: '#999999',
        fontWeight: 600,
    },
    stepName: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 600,
        color: '#111111',
    },
    stepNameMobile: {
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 600,
        color: '#111111',
    },
    prevButton: {
        fontWeight: 600,
        fontSize: 14,
        border: `1px solid ${theme.primaryColor}`,
        borderRadius: '4px !important',
        color: theme.primaryColor,
        '&:hover': {
            borderColor: theme.primaryColor,
            color: theme.primaryColor,
        },
    },
    nextButton: {
        borderRadius: 8,
        fontWeight: 600,
        fontSize: 14,
    },
});

export const stepOneStyles = (theme: ThemeType) => ({
    ...commonStyles(theme),
    boxTitle: {
        ...commonStyleSheet(theme).flexColumn,
        fontSize: 16,
        color: '#333333',
        fontWeight: 'bold',
        width: '15%',
    },
    boxFields: {
        width: '100%',
        display: 'flex',
    },
    boxFieldsRadio: {
        width: '100%',
        display: 'flex',
        '& .ant-radio-wrapper': {
            display: 'inline',
            color: '#111111',
            fontFamily: 'Open Sans',
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0,
            // margin: '4px 24px 4px 0px',
        },
    },
    boxFieldsCol: {
        width: '80%',
        ...commonStyleSheet(theme).flexColumn,
    },
    boxIcon: {
        width: '100%',
        height: 30,
        fontSize: 16,
        color: '#333333',
        textAlign: 'left',
    },
    box: {
        ...commonStyleSheet(theme).flexColumn,
        padding: 20,
        alignItems: 'normal',
        boxSizing: 'border-box',
        borderRadius: 4,
        backgroundColor: '#FFFFFF',
        width: '100%',
    },
    reference: {
        ...commonStyleSheet(theme).flexColumn,
        alignContent: 'flex-start',
        width: '100%',
    },
    weight: {
        width: '32%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 16,
        marginRight: 100,
        '& .ant-input-group > .ant-input:first-child': {
            width: 150,
            marginRight: 0,
        },
        '& .ant-select-selection-item, .ant-select-single.ant-select-show-arrow': {
            color: '#111111',
            fontSize: 12,
            fontWeight: 600,
        },
    },
    formItem: {
        width: '45%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        marginBottom: 16,
        '& .ant-checkbox + span': {
            color: '#111111',
            fontSize: 14,
            fontWeight: 600,
        },
    },
    formItemWeight: {
        width: '45%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        marginBottom: 16,
        '& .ant-input-wrapper': {
            width: 250,
        },
    },
    referenceItem: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 16,
    },
    dimensions: {
        ...commonStyleSheet(theme).flexColumn,
        width: 250,
        alignItems: 'left',
        marginBottom: 16,
    },
    description: {
        ...commonStyleSheet(theme).flexColumn,
        width: '80%',
    },
    contentType: {
        width: 250,
        ...commonStyles(theme).flexRow,
    },
    deliveryType: {
        width: '25%',
        ...commonStyleSheet(theme).flexColumn,
    },
});

export const itemDetailsStyles = (theme: ThemeType) => ({
    ...commonStyles(theme),
    main: {
        ...commonStyles(theme).main,
        paddingBottom: 0,
        maxHeight: undefined,
        minHeight: undefined,
        fontFamily: 'Open Sans',
        letterSpacing: 0,
        '& .ant-drawer-header': {
            padding: 12,
        },
        '& .ant-drawer-body': {
            padding: 0,
            backgroundColor: '#FFF',
        },
        '& .ant-btn-primary': {
            borderRadius: 4,
        },
        marginBottom: 100,
    },
    header: {
        ...commonStyleSheet(theme).flexRow,
        fontWeight: 600,
        fontSize: 20,
        color: '#000000',
        width: '100%',
        justifyContent: 'space-between',
        padding: 0,
        fontFamily: 'Open Sans',
        letterSpacing: 0,
    },
    title: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
        marginLeft: 4,
    },
});

export const stepTwoStyles = (theme: ThemeType) => ({
    ...commonStyles(theme),
    main: {
        ...commonStyles(theme).main,
        maxHeight: undefined,
        minHeight: undefined,
    },
    searchAddress: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'flex-end',
        margin: 0,
    },
    consigneeDetailsInput: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'space-between',
        margin: 0,
        '& .ant-radio-wrapper': {
            display: 'inline',
            color: '#111111',
            fontFamily: 'Open Sans',
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0,
            height: 32,
        },
    },
    searchText: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
    },
    addressList: {
        ...commonStyleSheet(theme).flexColumn,
        // marginBottom: 12,
        // maxHeight: 500,
        overflow: 'auto',
    },
    addressLine: {
        display: 'flex',
        flexDirection: 'column',
        padding: 12,
        width: '98%',
        borderRadius: 4,
        backgroundColor: '#FCFCFC',
        margin: '4px 0px',
        cursor: 'pointer',
    },
    addressLineSelected: {
        backgroundColor: `${theme.tertiaryFillColor} !important`,
    },
    addressDetails: {
        ...commonStyleSheet(theme).flexRow,
        // justifyContent: 'space-between',
        alignItems: 'top',
        width: '100%',
        marginTop: 16,
    },
    consigneeDetails: {
        alignItems: 'top',
        width: '100%',
        margin: '16px 0 0 16px',
    },
    addressLineDetails: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'space-between',
        alignItems: 'top',
        width: '100%',
        padding: '0px 10px 0px 25px',
    },
    addressMenu: {
        ...commonStyleSheet(theme).flexColumn,
        marginTop: 16,
        minWidth: 188,
        boxSizing: 'border-box',
        width: 1,
        borderRight: '1px solid #EDEDED',
        fontFamily: 'Open Sans',
        fontSize: 14,
        letterSpacing: 0,
        main: {
            '& .ant-radio-wrapper': {
                backgroundColor: 'blue',
            },
        },
    },
    addressItem: {
        ...commonStyleSheet(theme).flexRow,
        height: 42,
        width: 188,
        alignItems: 'center',
        cursor: 'pointer',
    },
    addressItemSelected: {
        ...commonStyleSheet(theme).flexRow,
        height: 42,
        width: 188,
        alignItems: 'center',
        cursor: 'pointer',
        fontWeight: 'bold',
        borderRight: `4px solid ${theme.secondryColor}`,
    },
    tabIcon: {
        height: 24,
        width: 24,
        borderRadius: 12,
        margin: '0px 10px',
    },
    filledCircle: {
        height: 20,
        width: 20,
        borderRadius: 10,
        border: '2px solid #FFF',
    },
});

export const consignorDetailsStyles = (theme: ThemeType) => ({
    ...stepTwoStyles(theme),
    main: {
        ...commonStyles(theme).main,
        paddingBottom: 0,
        maxHeight: undefined,
        minHeight: undefined,
        fontFamily: 'Open Sans',
        letterSpacing: 0,
        '& .ant-drawer-header': {
            padding: 12,
        },
        '& .ant-drawer-body': {
            padding: 0,
            backgroundColor: '#FFF',
        },
        '& .ant-btn-primary': {
            borderRadius: 4,
        },
        '& .ant-radio-wrapper': {
            display: 'inline',
            color: '#111111',
            fontFamily: 'Open Sans',
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0,
            height: 32,
        },
        // '&.ant-upload-list'.ant-upload-list-text
        marginBottom: 50,
    },
    header: {
        ...commonStyleSheet(theme).flexRow,
        fontWeight: 600,
        fontSize: 20,
        color: '#000000',
        width: '100%',
        justifyContent: 'space-between',
        padding: 0,
        fontFamily: 'Open Sans',
        letterSpacing: 0,
    },
    title: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
        marginLeft: 4,
    },
});

export const stepFourStyles = (theme: ThemeType) => ({
    ...commonStyles(theme),
    main: {
        ...commonStyles(theme).main,
        '& .ant-radio-wrapper': {
            display: 'inline',
            color: '#111111',
            fontFamily: 'Open Sans',
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0,
        },
    },
    fields: {
        width: '100%',
        marginTop: 20,
        ...commonStyles(theme).flexRow,
        justifyContent: 'flex-start',
    },
    input: {
        marginRight: 12,
    },
    amount: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: 20,
        '& .ant-input-group > .ant-input:first-child': {
            width: 150,
            marginRight: 0,
        },
        '& .ant-select-selection-item, .ant-select-single.ant-select-show-arrow': {
            color: '#111111',
            fontSize: 12,
            width: 65,
            fontWeight: 600,
        },
    },
    inFavour: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: 20,
    },
    label: {
        color: '#333333',
        fontSize: 12,
    },
    formItem: {
        width: '100%',
    },
    contentType: {
        width: '150%',
        ...commonStyles(theme).flexRow,
    },
    subclass: {
        margin: '5%',
        display: 'flex',
        textAlign: 'center',
    },
    classMargin: {
        marginLeft: 4,
        marginRight: 4,
    },
    boxDummy: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        width: 600,
    },
});

export const scheduleStepStyles = (theme: ThemeType) => ({
    ...commonStyles(theme),
    boxFields: {
        width: '100%',
        '& .ant-checkbox-wrapper + .ant-checkbox-wrapper': {
            margin: 0,
            marginTop: 6,
        },
    },
    servicesHeader: {
        width: '100%',
        fontSize: 16,
        gap: 8,
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        backgroundColor: '#fefefe',
        padding: '4px 8px',
        border: '1px solid #ebebeb',
        borderRadius: '4px',
        marginBottom: '4px',
    },
    servicesMain: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginLeft: '10px',
        '& .ant-collapse-borderless > .ant-collapse-item': {
            border: 'none',
        },
        '& .ant-collapse-borderless': {
            background: 'inherit',
            width: '100%',
        },
        '& .ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: '0px',
        },
        '& .ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
            paddingTop: '8px !important',
            paddingBottom: '0px !important',
        },
    },
    panel: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 4,
        width: '100%',
        '& .ant-collapse-borderless > .ant-collapse-item': {
            border: 'none',
        },
        '& .ant-empty-normal': {
            margin: 'auto',
        },
    },
    expandAllHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 12,
    },
    expandCollapseOptions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        justifySelf: 'end',
        marginRight: '4px',
        cursor: 'pointer',
        '& .ant-btn': {
            height: '18px !important',
            padding: '0px 2px !important',
        },
        '& .ant-btn-text': {
            color: theme.primaryColor,
        },
    },
    radioGroup: {
        display: 'flex',
        width: '100%',
        '& .ant-radio-wrapper': {
            display: 'flex !important',
            width: '100% !important',
            margin: '0 !important',
        },
        '& .ant-radio-wrapper > span:last-child': {
            flex: '1 !important',
            width: '100% !important',
        },
    },
    alternateOptions: {
        display: 'flex !important',
        gap: '4px',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        borderRadius: 8,
        padding: '1px 6px',
        marginTop: '2px !important',
        fontSize: '10px',
        marginRight: '-10px !important',
    },
    errorList: {
        border: '1px solid #eae9e0',
        backgroundColor: '#fffcf3',
        borderRadius: 8,
        padding: '4px 8px',
        marginTop: '4px',
    },
    errorHeading: {
        fontSize: 12,
        color: '#ac811a',
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
    },
    serviceCard: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },
    serviceOption: {
        width: '100%',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        padding: '12px',
        paddingRight: '16px',
        marginBottom: '12px',
        alignContent: 'center',
        boxSizing: 'border-box',
        '& .ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header': {
            padding: '0px 0px 0px 4px',
        },
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: '4px 0px',
        },
        '& .ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            right: '2px !important',
        },
    },
    serviceOptionSelected: {
        background: `${theme.tertiaryFillColor} !important`,
        border: '1px solid #7a8eb5',
    },
    serviceCardLeft: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        width: '100%',
    },
    serviceCardRight: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    radio: {
        display: 'flex',
        width: '100%',
        color: '#111111',
        fontSize: 14,
        fontWeight: 600,
        borderRadius: 4,
        backgroundColor: '#FCFCFC',
        padding: 12,
        alignItems: 'center',
        '& .ant-checkbox + span': {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
    },
    radioSelected: {
        backgroundColor: '#E7F5FF',
    },
    checkbox: {
        display: 'flex',
        width: '90%',
        color: '#111111',
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0,
        padding: 12,
        borderRadius: 4,
        backgroundColor: '#FCFCFC',
    },
    checkboxBody: {
        '& .ant-checkbox + span': {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
    },
    checkboxSelected: {
        backgroundColor: '#E7F5FF',
    },
    tatIcon: {
        height: 18,
        width: 18,
    },
    arrowIcon: {
        display: 'inline-block',
        transition: 'transform 0.3s ease',
        cursor: 'pointer',
    },
    serviceInfoRow: {
        display: 'flex',
    },
    errorListCollapse: {
        width: '100%',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease',
    },
    unavailableCard: {
        width: '100%',
        flexDirection: 'column',
    },
    unavailableCardHeader: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'nowrap',
    },
    unavailableServiceName: {
        flex: 1,
        fontSize: 14,
        fontWeight: 550,
        opacity: 0.5,
        minWidth: 0,
    },
    servicesRelativeContainer: {
        position: 'relative',
    },
    scrollContainerAvailable: {
        maxHeight: '360px',
        overflowY: 'scroll',
    },
    scrollContainerUnavailable: {
        maxHeight: '1000px',
        overflowY: 'scroll',
        width: '100%',
    },
    shadowBase: {
        position: 'absolute',
        left: 0,
        width: '100%',
        height: '20px',
        pointerEvents: 'none',
        zIndex: 1,
        transition: 'opacity 0.3s ease',
    },
    shadowTop: {
        top: 0,
        background: 'linear-gradient(to top, rgba(255,255,255,0), rgba(0,0,0,0.05))',
        borderRadius: '4px 4px 0 0',
    },
    shadowBottom: {
        bottom: 0,
        background: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(0,0,0,0.05))',
        borderRadius: '0 0 4px 4px',
    },
});
